import React, { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'antd';

import AiIcon from '../AiIcon';

type Props = {
  value?: string;
  className?: string;
  accept?: string;
  onChange?: (file: File) => void;
};

export default function UploadFileButton({
  value,
  className,
  accept,
  onChange,
}: Props) {
  const [preview, setPreview] = useState<string | null>(null);
  const fileInput = React.useRef<HTMLInputElement>(null);
  const version = useMemo(() => Date.now(), []);

  useEffect(() => {
    if (value) {
      setPreview(`${value}?v=${version}`);
    }
  }, [value, version]);

  const onClickFile = () => {
    fileInput.current?.click();
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (window?.FileReader) {
      setPreview(null);

      const reader = new FileReader();
      reader.onload = (oFREvent) => {
        setPreview((oFREvent.target?.result as string) || null);
      };
      reader.readAsDataURL(file);
    }

    onChange?.(file);
  };

  const v = preview || (typeof value === 'string' ? value : '');

  return (
    <div className={`upload-files-btn ${className || ''}`}>
      <input
        type="file"
        accept={accept}
        onChange={handleChange}
        ref={fileInput}
        style={{ display: 'none' }}
      />

      <Button onClick={onClickFile} className="support-ask-modal__upload-btn">
        <AiIcon name="upload" />
        <FormattedMessage id="buttons.upload" />
      </Button>

      {preview && v && (
        <div
          className="upload-file"
          style={{
            backgroundImage: v ? `url("${v}")` : undefined,
          }}
        />
      )}
    </div>
  );
}
